import React from 'react';
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import CommonHeaderRight from './CommonHeaderRight';

const FeaturedCenterDetailHeader = () => {
	return (
		<Header>
			<HeaderLeft className='h4 mb-0 fw-bold'>Featured-center Detail</HeaderLeft>
			<CommonHeaderRight />
		</Header>
	);
};

export default FeaturedCenterDetailHeader;
